import { CheckInput } from "../../atoms/CheckInput";
import {
  CautionText,
  ItemWrapper,
  ResendWelcomeMailLayout,
  ResendWelcomeMailLayoutProps,
} from "./ResendWelcomeMailLayout";

/**
 * ウェルカムメール再送ページ (アカウント統合用のシークレットコードを再発行する契約向け)
 */
export type ResendIntegrationWelcomeMailPageProps = Omit<
  ResendWelcomeMailLayoutProps,
  "children"
> & {
  reissueIntegrationToken: boolean;
  onChangeReissueIntegrationToken: (checked: boolean) => void;
};

export function ResendIntegrationWelcomeMailPage({
  reissueIntegrationToken,
  onChangeReissueIntegrationToken,
  ...layoutProps
}: ResendIntegrationWelcomeMailPageProps) {
  return (
    <ResendWelcomeMailLayout {...layoutProps}>
      <ItemWrapper width="100%" $caution $bold>
        <CautionText $marginBottom="12px">
          製品管理責任者宛にWelcomeメールを再送します。
          <br />
          パスワードのリセットは行われません。
        </CautionText>
      </ItemWrapper>
      <ItemWrapper width="100%">
        <CheckInput
          checked={reissueIntegrationToken}
          onChange={(e) => {
            onChangeReissueIntegrationToken(e.target.checked);
          }}
          label={"アカウント統合用のシークレットコードを再発行する"}
        />
      </ItemWrapper>
    </ResendWelcomeMailLayout>
  );
}
